<template>
  <div class="page-container">
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/1 md:w-1/2 h-64 sm:h-64 md:h-screen"
        >
          <img
            class="w-full h-64 sm:h-64 md:h-screen object-cover object-center"
            src="@/assets/img/demo5.png"
            alt="Toyota"
          />
        </div>
        <!-- ... -->
        <div
          class="w-full sm:w-1/1 md:w-1/2 authorize-container h-auto sm:h-auto md:h-screen"
        >
          <div
            class="flex flex-col justify-center items-center sm:min-auto min-h-full h-full"
          >
            <h1 class="mb-8">
              <router-link :to="{ name: 'index'}" class="main-logo">
                <img src="@/assets/img/logo.png" alt="Toyota" />
              </router-link>
            </h1>
            <p class="text-left mb-8 page-title">
              Xác nhận mật mã OTP
            </p>
            <div
              class="w-full sm:w-full md:w-auto form-container"
            >
              <div class="mb-4 form-controls">
                <label
                  class="block text-sm font-bold mb-2"
                >
                  Nhập mã OTP bạn vừa nhận
                </label>
                <div id="digit-group">
                  <div class="digit-group">
                      <OTPInput
                        ref="otpInput"
                        :isDisabled="false"
                        :isError="false"
                        :onChangeOTP="onChangeOTP"
                        :shouldResetOTP="true"
                        :numberOfInput="6"
                      />
                      <p
                        :class="[ error !== '' ? 'block' : 'hidden' ]"
                        class="text-red-400 text-error mb-4"
                      >
                        {{error}}
                      </p>
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
                  @click="submitVerify"
                >
                  <vue-element-loading :active="isRequest"/>
                  Tiếp tục
                </button>
                <div class="text-center underline">
                  <a href="#" @click="requestResendOtp">
                    <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                      <template slot-scope="props">Vui lòng thử lại sau {{ props.totalSeconds }} giây</template>
                    </countdown>
                    <span v-else>Gửi lại mã OTP</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OTPInput from '@/components/OTPInput.vue'
import { AuthService } from '@/services/auth.service'

export default {
  name: 'ForgetPasswordOTP',
  data () {
    return {
      otp: '',
      username: this.$route.params.username,
      isRequest: false,
      error: '',
      counting: false
    }
  },
  methods: {
    submitVerify () {
      this.isRequest = true
      AuthService.confirmForgetPassword(this.username, this.otp).then(response => {
        if (response.data.data.IsResult === false) {
          this.error = response.data.Message
          this.isRequest = false
          return
        }
        this.error = ''
        this.$store.commit('toast/NEW', { type: 'success', message: 'Email đổi mật khẩu đã được gửi!' })
        this.isRequest = false
        this.$router.push({ name: 'login' })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    onChangeOTP (otp) {
      this.otp = otp
    },
    requestResendOtp () {
      if (this.counting === true) return
      this.counting = true
      AuthService.resendOTPByUsername(this.username).then(response => {
        if (response.data.data.IsResult === false) {
          this.success = ''
          this.error = response.data.Message
          this.success = ''
          return
        }
        this.error = ''
        this.success = response.data.Message // response.data.Message
      }).catch((error) => {
        console.log(Object.assign({}, error))
        this.$store.commit('toast/NEW', { type: 'error', message: 'Có lỗi xảy ra!' })
      })
    },
    handleCountdownEnd: function () {
      this.counting = false
    }
  },
  components: {
    OTPInput
  },
  created () {
    this.$nextTick(() => {
      this.$refs.otpInput.focusFirstInput()
    })
  }
}
</script>
